<template>
  <div class="modal modal-mask">
    <div class="modal-dialog modal-wrapper">
      <div
        class="modal-content modal-container"
        :style="containerStyle"
        v-loading="loading"
      >
        <div class="modal-header py-1 gap-3">
          <div class="modal-title h5 mb-0 flex-grow-1">
            <slot name="header"> Warning </slot>
          </div>
          <button
            type="button"
            class="btn btn-link btn-sm border-0 p-1 mb-0 flex-shrink-0 ms-auto"
            aria-label="Cerrar modal"
            @click="hideModal"
          >
            <i class="el-icon-close fs-6" aria-hidden="true"></i>
          </button>
        </div>
        <slot name="sub-header"></slot>

        <div class="modal-body" :class="bodyClass" :style="bodyStyle">
          <slot name="body"> Seguro desea realizar esta acción </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-danger" @click="$emit('hide')">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('accepted')"
            >
              Aceptar
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      required: false,
      default: () => false,
    },
    width: { type: [String, Number], default: null },
    minWidth: { type: [String, Number], default: null },
    maxWidth: { type: [String, Number], default: null },
    height: { type: [String, Number], default: null },
    minHeight: { type: [String, Number], default: null },
    maxHeight: { type: [String, Number], default: null },
    bodyClass: { type: [String, Array, Object], default: null },
    bodyMinHeight: { type: [String, Number], default: null },
    bodyMaxHeight: { type: [String, Number], default: null },
  },
  computed: {
    containerStyle() {
      return ["width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight"]
        .reduce((style, property) => {
          style[property] = this.cssSize(this[property]);
          return style;
        }, {});
    },
    bodyStyle() {
      return {
        minHeight: this.cssSize(this.bodyMinHeight),
        maxHeight: this.cssSize(this.bodyMaxHeight),
      };
    },
  },
  methods: {
    cssSize(value) {
      return typeof value === "number" ? `${value}px` : value;
    },
    hideModal() {
      this.$emit("hide");
    },
  },
};
</script>

<style>
.color {
  background-color: #ffffff;
  border: none;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
